import { IServiceDobleAuthenticationUser } from './IServiceDobleAuthenticationUser'
import type { IDobleAuthenticationUserRepository } from '../domain/IDobleAuthenticationUserRepository'
import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'
import { UsuarioDobleAutenticacion } from '../domain/usuarioDobleAutenticacion'

@injectable()
export class DobleAuthenticationUserService implements IServiceDobleAuthenticationUser {
  private readonly dobleAuthenticationUserRepo: IDobleAuthenticationUserRepository

  public constructor (@inject(TYPES.DOBLE_FACTOR_USER_REPOSITORY) _dobleAuthenticationUserRepo: IDobleAuthenticationUserRepository) {
    this.dobleAuthenticationUserRepo = _dobleAuthenticationUserRepo
  }

  async getDobleFactorUserCode (userId: number): (Promise<UsuarioDobleAutenticacion>) {
    return await this.dobleAuthenticationUserRepo.getDobleFactorUserCode(userId)
  }

  async setDobleFactorUserCode (userId: number, dobleFactorType: string): (Promise<UsuarioDobleAutenticacion>) {
    return await this.dobleAuthenticationUserRepo.setDobleFactorUserCode(userId, dobleFactorType)
  }

  async confirmDobleFactorUser (userId: number): (Promise<UsuarioDobleAutenticacion>) {
    return await this.dobleAuthenticationUserRepo.confirmDobleFactorUser(userId)
  }
}
